<template>
  <div class="profile">
    <div class="container">
      <div class="profile__update" style="margin: 56px 0">
        <div class="update-form">
          <div class="update-form__top">
            <h2 class="update-form__title">Dados do operador</h2>
            <p
              v-show="hasUpdated && type === 'update'"
              class="success-form-msg"
            >
              Dados do operador atualizados com sucesso!
              <BIconX @click="onCloseSuccessMessage" />
            </p>
            <p
              v-show="hasUpdated && type === 'create'"
              class="success-form-msg"
            >
              Operador criado com sucesso!
              <BIconX @click="onCloseSuccessMessage" />
            </p>
          </div>

          <form class="update-form__form">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Nome completo</label>
                <input
                  v-model="$v.operator.name.$model"
                  class="form-control"
                  type="text"
                  placeholder="Nome"
                />

                <div v-if="$v.operator.name.$error">
                  <div v-if="!$v.operator.name.required" class="error">
                    Campo obrigatório
                  </div>
                </div>
              </div>

              <div class="form-group col-md-6">
                <label>Email</label>
                <input
                  v-model="$v.operator.email.$model"
                  class="form-control"
                  type="email"
                  placeholder="E-Mail"
                />
              </div>

              <div class="form-group col-md-6">
                <label>Senha</label>
                <input
                  v-model="$v.operator.password.$model"
                  class="form-control"
                  type="password"
                  placeholder="Senha"
                />
              </div>
            </div>
          </form>

          <div class="update-form__buttons">
            <button
              class="button4"
              :class="[disableUpdateButton ? 'disable' : '']"
              :disabled="disableUpdateButton"
              type="button"
              @click="handleSubmit"
            >
              Salvar alterações
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  userComputed,
  userMethods,
  operatorMethods,
  operatorState as operatorComputed
} from "../../state/helpers";

import { email, required } from "vuelidate/lib/validators";

export default {
  name: "OperatorProfile",
  props: {
    type: { type: String, default: "" }
  },
  data() {
    return {
      operator: {
        name: "",
        email: "",
        password: ""
      },
      hasUpdated: false
    };
  },
  mounted() {
    if (this.type === "update") {
      this.operator = Object.assign(
        {},
        {
          name: this.currentUser.name,
          email: this.currentUser.email,
          password: ""
        }
      );
    }
  },
  methods: {
    ...userMethods,
    ...operatorMethods,
    onCloseSuccessMessage() {
      this.hasUpdated = false;
    },
    createOperator() {
      if (!this.$v.operator.$invalid) {
        this.register(this.$data.operator);
        this.hasUpdated = !this.errorMessage;
      }
    },
    updateOperator() {
      if (!this.$v.operator.$invalid) {
        const user = { ...this.$data.operator };
        user.id = this.currentUser.id;
        this.updateAnOperator(user);
        this.hasUpdated = !this.errorMessage;
      }
    },
    handleSubmit() {
      if (this.type === "update") {
        return this.updateOperator();
      } else this.createOperator();
    }
  },
  computed: {
    ...userComputed,
    ...operatorComputed,
    disableUpdateButton() {
      return this.$v.operator.$invalid;
    }
  },
  validations: {
    operator: {
      name: { required },
      email: { required, email },
      password: { required }
    }
  }
};
</script>

<style scoped>
/* PROFILE NAV */
.profile__nav {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 82px;
  width: 100%;
  margin-bottom: 36px;
  background: #ffffff;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
}
.profile__nav-link {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-decoration: none;
  font-family: "Public" sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: -0.5px;
  color: #999999;
  margin-right: 45px;
  outline: none;
}
@media (max-width: 767px) {
  .profile__nav {
    flex-direction: column;
    height: auto;
  }
  .profile__nav-link {
    margin: 45px 0px 45px 0px;
  }
}
.profile__nav-icon {
  height: 20px;
  width: 20px;
  margin-bottom: 8px;
}
/* PROFILE UPDATE */
.profile__update {
  display: flex;
  justify-content: center;
  padding: 40px;
  background: #ffffff;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
}
/* PROFILE UPDATE PHOTO */
.update-photo {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-right: 20px;
}
.photo {
  position: relative;
  width: 166px;
  cursor: pointer;
  margin: 0 auto;
}
.photo-img {
  display: block;
  height: 166px;
  width: 100%;
  border-radius: 50%;
  background-color: #eeeeee;
  border: solid 1px #dddddd;
}
.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 166px;
  height: 166px;
  background: rgba(0, 0, 0, 0.4);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  opacity: 0;
}
.photo-overlay:hover {
  opacity: 1;
}
.photo-text {
  font-weight: 600;
  color: #6b7070;
  text-align: center;
  margin-top: 20px;
  font-family: "Inter" sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
}
.update-photo__input {
  display: none;
}
@media (max-width: 767px) {
  .profile__update {
    flex-direction: column;
  }
  .update-photo {
    margin-right: 0px;
    margin-bottom: 40px;
    align-items: center;
    justify-content: center;
  }
}
/* PROFILE UPDATE FORM */
.update-form {
  flex: 4;
  font-family: "Inter" sans-serif;
  font-style: normal;
}
.update-form__top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.update-form__title {
  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.5px;
  color: #303535;
  margin-bottom: 32px;
}
.success-form-msg {
  min-width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  background: #eef5f6;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #f8002d;
  transition: all 0.3s ease;
}
.success-form-msg svg {
  width: 26px;
  height: 26px;
  cursor: pointer;
}
@media (max-width: 767px) {
  .update-form__top {
    flex-direction: column;
  }

  .success-form-msg {
    min-width: 100%;
  }
}
.update-form__form label {
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.5px;
  color: #303535;
}
.form-group {
  padding-top: 16px !important;
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
}
.form-control,
.custom-select {
  height: 48px !important;
  border: solid 1px #dddddd !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  font-family: "Inter" sans-serif !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 14px !important;
  line-height: 120% !important;
  letter-spacing: -0.5px !important;
  color: #6b7070 !important;
}
.form-control:focus,
.custom-select:focus {
  box-shadow: none !important;
  border: solid 1px #222222 !important;
}
.form-control::placeholder {
  font-size: 14px !important;
}
.update-form__buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 34px;
}
@media (max-width: 767px) {
  .update-form__buttons {
    align-items: center;
  }
}
.change-password__btn {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  text-decoration-line: underline;
  color: #f8002d;
}
.button4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 32px;
  background: #f8002d;
  border-radius: 8px;
  color: #ffffff;
  transition: all 0.3s ease;
}
.button4:hover,
.button4:active {
  outline: 0;
  color: #ffffff;
  background: #51929a;
}
.error {
  color: red;
}
.disable {
  background-color: rgba(128, 128, 128, 0.542);
  border: 1px solid;
}
.disable:hover {
  background-color: rgba(128, 128, 128, 0.542);
}
</style>
